// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILuGpDesignationAllowedPropertyDto
 */
export interface ILuGpDesignationAllowedPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof ILuGpDesignationAllowedPropertyDto
     */
    lu_gp_designation_allowed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ILuGpDesignationAllowedPropertyDto
     */
    lu_gp_designation_allowed_state?: ILuGpDesignationAllowedPropertyDtoLuGpDesignationAllowedStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ILuGpDesignationAllowedPropertyDtoLuGpDesignationAllowedStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ILuGpDesignationAllowedPropertyDto interface.
 */
export function instanceOfILuGpDesignationAllowedPropertyDto(value: object): value is ILuGpDesignationAllowedPropertyDto {
    return true;
}

export function ILuGpDesignationAllowedPropertyDtoFromJSON(json: any): ILuGpDesignationAllowedPropertyDto {
    return ILuGpDesignationAllowedPropertyDtoFromJSONTyped(json, false);
}

export function ILuGpDesignationAllowedPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILuGpDesignationAllowedPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lu_gp_designation_allowed': json['lu_gp_designation_allowed'] == null ? undefined : json['lu_gp_designation_allowed'],
        'lu_gp_designation_allowed_state': json['lu_gp_designation_allowed_state'] == null ? undefined : json['lu_gp_designation_allowed_state'],
    };
}

export function ILuGpDesignationAllowedPropertyDtoToJSON(json: any): ILuGpDesignationAllowedPropertyDto {
    return ILuGpDesignationAllowedPropertyDtoToJSONTyped(json, false);
}

export function ILuGpDesignationAllowedPropertyDtoToJSONTyped(value?: ILuGpDesignationAllowedPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lu_gp_designation_allowed': value['lu_gp_designation_allowed'],
        'lu_gp_designation_allowed_state': value['lu_gp_designation_allowed_state'],
    };
}

